import React from 'react';
import { ThemeToggleButton } from './Header.style';

const SunIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="5" />
    <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
  </svg>
);

const MoonIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden="true"
  >
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

const getInitialTheme = () => {
  const attr = document?.documentElement?.getAttribute?.('data-theme');
  return attr === 'light' ? 'light' : 'dark';
};

const ThemeToggle = () => {
  const [theme, setTheme] = React.useState(getInitialTheme);

  React.useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const isDark = theme === 'dark';

  return (
    <ThemeToggleButton
      type="button"
      aria-label="Basculer le thème"
      data-theme-toggle
      onClick={() => setTheme((t) => (t === 'dark' ? 'light' : 'dark'))}
    >
      {isDark ? <MoonIcon /> : <SunIcon />}
    </ThemeToggleButton>
  );
};

export default ThemeToggle;

